module.exports = __webpack_public_path__ + "img/数智化领域方案全景图.408537a7.png";